import React from "react";
import { ReactComponent as PennyLogo } from "../../assets/icons/penny_logo.svg";
import { ReactComponent as BCorpLogo } from "../../assets/footer-icons/B Corp Black.svg";
import { ReactComponent as CentralBankLogo } from "../../assets/footer-icons/Central_Bank_of_Ireland_Logo_Black.svg";
import { ReactComponent as EnterpriseIrelandLogo } from "../../assets/footer-icons/Enterprise Ireland new logo transparent black.svg";
import { ReactComponent as AvivaLogo } from "../../assets/footer-icons/Aviva_Insurance_logo_black.svg";
import { ReactComponent as NewIrelandLogo } from "../../assets/footer-icons/New Ireland Black.svg";
import { ReactComponent as ZurichLogo } from "../../assets/footer-icons/Zurich_logo_black.svg";

type FooterProps = {};
//todo: implement calendly link
const Footer: React.FC<FooterProps> = () => {
  return (
    <div className="px-4  py-0 lg:py-[64px] flex flex-col gap-y-0 md:gap-y-10 isolate relative overflow-hidden bg-[#FCFCF7]">
      <div className="flex flex-col md:flex-row items-start gap-x-[22px]">
        {/* Left section: Logo and large-screen Contact Us button */}
        <div className="flex flex-col md:gap-y-[26px] max-w-full md:max-w-[300px] lg:max-w-[500px] w-full">
          <div className="flex flex-col gap-y-0 md:gap-y-2.5">
            <PennyLogo className="w-[210px] h-[85px]" />
          </div>

          {/* New Contact Us button for larger screens */}
          <div className="hidden lg:block py-4">
            <a href="mailto:hey@thisispenny.com" rel="noopener noreferrer" className="btn-primary-lg">Contact Us</a>
          </div>
        </div>

        {/* Right section: Link columns */}
        <div className="flex flex-wrap md:flex-nowrap md:grid md:grid-cols-4 w-full place-items-start md:place-items-stretch gap-4 py-6 md:py-0 md:gap-x-[17px] flex-1">
          <div className="flex flex-col gap-y-2.5 w-1/2 md:w-auto">
            <a href="https://www.thisispenny.com/company" rel="noopener noreferrer" className="text-pn-callout-emphasis">About</a>
            <div className="flex flex-col gap-y-2">
              <a href="https://www.thisispenny.com/company#mission" rel="noopener noreferrer" className="text-pn-callout-regular hover:underline">Purpose</a>
              <a href="https://www.thisispenny.com/company#mission" rel="noopener noreferrer" className="text-pn-callout-regular hover:underline">Mission</a>
              <a href="https://www.thisispenny.com/company#values" rel="noopener noreferrer" className="text-pn-callout-regular hover:underline">Values</a>
            </div>
          </div>
          <div className="flex flex-col gap-y-2.5 w-1/2 md:w-auto">
            <a href="https://www.thisispenny.com/customer-care" rel="noopener noreferrer" className="text-pn-callout-emphasis">Customer Care</a>
            <div className="flex flex-col gap-y-2">
              <a href="https://www.thisispenny.com/contact" rel="noopener noreferrer" className="text-pn-callout-regular hover:underline">Contact us</a>
              <a href="https://www.thisispenny.com/customer-care#faq" rel="noopener noreferrer" className="text-pn-callout-regular hover:underline">FAQ</a>
            </div>
          </div>
          <div className="flex flex-col gap-y-2.5 w-1/2 md:w-auto">
            <span className="text-pn-callout-emphasis">Social</span>
            <div className="flex flex-col gap-y-2">
              <a href="https://www.instagram.com/_thisispenny/" target="_blank" rel="noopener noreferrer" className="text-pn-callout-regular hover:underline">Instagram</a>
              <a href="https://www.linkedin.com/company/this-is-penny/" target="_blank" rel="noopener noreferrer" className="text-pn-callout-regular hover:underline">LinkedIn</a>
              <a href="https://open.spotify.com/user/31dvnirfn7xgkjnqtzwemmsl3vnm" target="_blank" rel="noopener noreferrer" className="text-pn-callout-regular hover:underline">Spotify</a>
            </div>
          </div>
          <div className="flex flex-col gap-y-2.5 w-1/2 md:w-auto">
            <span className="text-pn-callout-emphasis">Legals</span>
            <div className="flex flex-col gap-y-2">
              <a href="https://www.thisispenny.com/terms-of-business" rel="noopener noreferrer" className="text-pn-callout-regular hover:underline">Terms of Business</a>
              <a href="https://www.thisispenny.com/remuneration" rel="noopener noreferrer" className="text-pn-callout-regular hover:underline">Remuneration</a>
              <a href="https://www.thisispenny.com/privacy-policy" rel="noopener noreferrer" className="text-pn-callout-regular hover:underline">Privacy Policy</a>
              <a href="https://www.thisispenny.com/cookie-policy" rel="noopener noreferrer" className="text-pn-callout-regular hover:underline">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>

      {/* Logos Section */}
      <div className="flex flex-col py-6 md:py-4 font-inter leading-[18px] font-normal text-pn_gray-950 gap-y-2">
        <div className="max-w-[250px] md:max-w-none text-[8px] md:text-[13px] leading-tight">
          Penny Life trading as This is Penny is regulated by the Central Bank of Ireland
        </div>
        <div className="grid grid-cols-3 items-center justify-items-center gap-x-4 gap-y-4 mt-4 md:flex md:justify-start md:gap-x-4 md:gap-y-0">
          <BCorpLogo className="w-28 h-14 md:w-40 md:h-20 object-contain mx-auto" />
          <CentralBankLogo className="w-28 h-14 md:w-40 md:h-20 object-contain mx-auto" />
          <EnterpriseIrelandLogo className="w-28 h-14 md:w-40 md:h-20 object-contain mx-auto" />
          <AvivaLogo className="w-28 h-14 md:w-40 md:h-20 object-contain mx-auto" />
          <NewIrelandLogo className="w-28 h-14 md:w-40 md:h-20 object-contain mx-auto" />
          <ZurichLogo className="w-28 h-14 md:w-40 md:h-20 object-contain mx-auto" />
        </div>
      </div>

      {/* Mobile Contact Us button, keeping as is per user request */}
      <div className="flex lg:hidden flex-col w-full py-4 mb-12 gap-y-4 text-center">
        <a href="mailto:hey@thisispenny.com" rel="noopener noreferrer" className="btn-primary-lg">Contact Us</a>
      </div>

      {/* Increased top padding for gap */}
      <div className="w-full mt-8 py-4 bg-[#F8E16C] absolute left-0 bottom-0">
        <div className="font-inter text-[13px] leading-[18px] font-semibold text-pn_gray-950 ml-5">
          © {new Date().getFullYear()}, Penny Life. All Rights Reserved.
        </div>
      </div>
    </div>
  );
};
export default Footer;
